module.exports = __webpack_public_path__ + "img/IMG-20191106-WA0032.03bd1207.jpg";